import styled, { css, keyframes } from "styled-components";
import Loading from "./assets/Loading";

const rotate = keyframes`
  from {
    transform: rotate(0);
  } to {
    transform: rotate(360deg);
  }
`;

const variants = {
  orange: css`
    background-color: var(--orange-primary);
    color: #fff;
  `,
  grey: css`
    background-color: rgba(54, 54, 54, 1);
    color: #fff;
  `,
};

const variantsHover = {
  orange: css`
    background-color: var(--orange-primary-hover);
  `,
  grey: css`
    background-color: #303030;
  `,
};

export const Wrapper = styled.button`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  justify-content: center;
  gap: 10px;
  width: ${({ $width }) => $width};
  line-height: 150%;
  border-radius: 8px;
  color: #fff;
  padding: 12px 24px;
  flex: 1;
  transition: 0.15s;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      ${({ $variant }) => variantsHover[$variant]}
    }
  }

  &:disabled {
    opacity: 60%;
    cursor: default;
  }

  ${({ $variant }) => variants[$variant]}
`;

export const LoadingIcon = styled(Loading)`
  animation: ${rotate} 800ms infinite;
  fill: #fff;
`;
